<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Change Password</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="confirmChangePassword">
          <div class="field">
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                ref="newPassword"
                placeholder="Password"
                v-model="newPassword"
                :disabled="isChangingPassword"
              />
              <span class="icon is-small is-left">
                <i class="icon-lock"></i>
              </span>
            </div>
            <p class="help is-danger" v-if="newPasswordError">{{ newPasswordError }}</p>
          </div>

          <input type="submit" style="display: none"/>
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="changePasswordError">
          {{changePasswordError}}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button
              class="button"
              @click="cancelChangePassword"
              :disabled="isChangingPassword"
            >Cancel</button>
            <button
              class="button is-primary"
              @click="confirmChangePassword"
              :class="{'is-loading': isChangingPassword}"
              :disabled="isChangingPassword"
            >Update password</button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  UPDATE_PASSWORD
} from "./userStore";

export default {
  name: "UserChangePasswordModal",

  props: {
    userStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      newPassword: undefined,
      isChangingPassword: false,
      newPasswordError: undefined,
      changePasswordError: undefined
    };
  },

  mounted() {
    this.$refs.newPassword.focus();
  },

  methods: {
    cancelChangePassword() {
      this.$emit("cancelled");
    },

    async confirmChangePassword() {
      if (this.newPassword === undefined || this.newPassword === "") {
        this.newPasswordError = "Password can not be empty";
        return;
      }

      if (this.newPassword.length < 6) {
        this.newPasswordError = "Password must be at least 6 characters";
        return;
      }

      this.changePasswordError = undefined;
      this.isChangingPassword = true;

      try {
        const updatePasswordAction = `${this.userStorePath}/${UPDATE_PASSWORD}`;
        await this.$store.dispatch(updatePasswordAction, { password: this.newPassword });

        this.$emit("succeeded");
      } catch (error) {
        this.changePasswordError = error || 'Something went wrong.';
      } finally {
        this.isChangingPassword = false;
      }
    }
  },

  watch: {
    newPassword() {
      this.newPasswordError = undefined;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
